module.exports = __webpack_public_path__ + "/images/shop/icon/ignition_plug.svg";